import React, { Component } from 'react';
import { isEmpty } from "lodash";

import {
    Box,
    Grid,
    Typography,
    Paper,
    Alert
} from  '@mui/material';

import Creatable from '../../common/Creatable';
import InputText, { InputSelectNative, InputSelect } from '../../common/Form';
import Dialog from '../../common/Dialog';
import { PAGES } from './AccessTypeForm';
// import { Alert } from '@mui/lab';

class UserUpdate extends Component {
    state = { 
        email: this.props.user.email,
        username: this.props.user.username || "",
        lastname: this.props.user.lastname || "",
        user_role: this.props.user.user_role,
        user_is_active: this.props.user.user_is_active || false,

        user_employee_id: this.props.user ? this.props.user.user_employee_id : "",
        user_employee_idDisplay: this.props.user && this.props.user.user_employee_id ? {
            value: this.props.user.user_employee_id, 
            label: `${this.props.EMPLOYEES[this.props.user.user_employee_id].employee_matricule} - ${this.props.EMPLOYEES[this.props.user.user_employee_id].employee_firstname} ${this.props.EMPLOYEES[this.props.user.user_employee_id].employee_lastname}`
        } : {value:"", label:""},

        user_type: this.props.user ? this.props.user.user_type : "",
        user_typeDisplay: this.props.user && this.props.user.user_type ? {
            value: this.props.user.user_type, 
            label: this.props.ACCESS[this.props.user.user_type].access_name
        } : {value:"", label:""},
        user_collab_account: this.props.user ? this.props.user.user_collab_account : "",
        user_super_email: this.props.user ? this.props?.user?.user_super_email || "" : "",

        errors:{
            email: "",
            username: "",
            lastname: "",
            user_role: "",
        }
    }
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        
        this.setState({
            [name]: value
        })
        
    }

    handleChangeEmployee = (option) => {
        if(option){
            this.setState({
                user_employee_id: option.value || "",
                user_employee_idDisplay: option
            })
        } else {
            this.setState({
                user_employee_id: "",
                user_employee_idDisplay: {}
            })

        }
    }
    handleChangeAccess = (option) => {
        if(option){
            this.setState({
                user_type: option.value || "",
                user_typeDisplay: option
            })
        } else {
            this.setState({
                user_type: "",
                user_typeDisplay: {}
            })

        }
    }
    validate = () => {
        let required = [
            "email",
            "username",
            "lastname",
            "user_role",
        ]
        
        let noError = true
        let errors = {}

       
        required.map(field => {
            if(!this.state[field]){
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })

        this.setState({
            errors
        })
    
        return noError
    }
    handleSubmit = async () => {
        if(this.validate()){
            let data = Object.assign({}, this.props.user, {
                user_id: this.props.user.user_id,
                email : this.state.email.trim(),
                username : this.state.username.trim(),
                lastname : this.state.lastname.trim().toUpperCase(),
                user_role : parseInt(this.state.user_role) || 1,
                user_is_active : this.state.user_is_active,
                user_employee_id : this.state.user_employee_id,
                user_type : this.state.user_type,
                user_collab_account : this.state.user_collab_account,
                user_super_email : this.state.user_super_email.trim(),
                user_update_date: new Date(),
            })
    
            console.log('====================================');
            console.log({data});
            console.log('====================================');

            //TODO : check email 

     

       
            /*
           const userFoundRespond =  await this.props.fetchUsersByEmail(data.email)
            
           console.log('============USER FOUND============');
              console.log({userFoundRespond});
                console.log('====================================');
            */
           



            await this.props.updateUser(data)  

            if(this.props.STATE.users.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.users.error}`)
            } else{
                this.props.notif("success","Le compte a été modifié avec succès")
                this.props.handleClose()
            }
        } else {
            this.props.notif("error", "Le formulaire contient des erreurs" )
        }
    }
    render() {
        const { EMPLOYEES, ACCESS } = this.props;
        console.log('====================================');
        console.log(this.state);
        console.log('====================================');
        return(
            <Dialog
                submitAction={this.handleSubmit} 
                disabledSubmit={this.props.STATE.users.fetching}
                close={this.props.handleClose}
                fullWidth
                maxWidth="md"
                appBar
                title="Modifier un Utilisateur"
            >
                <Box p={3}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="email" 
                                id="email" 
                                value={this.state.email} 
                                label="Email de l'utilisateur" 
                                placeholder="Email" 
                                error={this.state.errors.email} 
                                helperText={this.state.errors.email} 
                                onChange={this.handleChange}
                                 disabled
                            />
                        </Grid>
                        {this.props.user.user_role !== 3 &&
                        <Grid item xs={12} sm={6}>
                            <InputSelectNative
                                onChange={this.handleChange}
                                error={this.state.errors.user_role}
                                value={this.state.user_role}
                                labelWidth={40}
                                label="Role"
                                name="user_role" 
                                id="user_role" 
                                options={[
                                    <option value={1} >USER</option>,
                                    <option value={10}>USER +</option>,
                                    <option value={2} >ADMIN</option>,                                       
                                    <option value={4} >ADMIN +</option>
                                ]}
                            />
                        </Grid>
                        }
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="username" 
                                id="username" 
                                value={this.state.username} 
                                label="Prénom" 
                                placeholder="Prénom de l'utilisateur" 
                                error={this.state.errors.username} 
                                helperText={this.state.errors.username} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                required
                                name="lastname" 
                                id="lastname" 
                                value={this.state.lastname} 
                                label="Nom" 
                                placeholder="Nom de l'utilisateur" 
                                error={this.state.errors.lastname} 
                                helperText={this.state.errors.lastname} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        
                        {this.props.user.user_role !== 3 &&
                        <Grid item xs={12} sm={6}>
                            <InputSelectNative
                                // error={this.state.errors.user_is_active} 
                                labelWidth={50} 
                                name="user_is_active" 
                                id="user_is_active" 
                                label="Statut"
                                onChange={this.handleChange}
                                value={this.state.user_is_active}
                                options={[
                                    <option value={true} >Actif</option>,
                                    <option value={false} >Bloqué</option>                                        
                                ]}
                                helperText={this.state.user_is_active == "false" ? "L'utilisateur n'aura plus accès à la plateforme mais le compte ne sera pas supprimé" : ""}
                            />
                        </Grid>
                        }
                        <Grid item xs={12} sm={6}>
                            <Creatable
                                label="Compte Employé"
                                error={this.state.errors.user_employee_id}
                                id="user_employee_id"
                                options={Object.values(EMPLOYEES).map( item => ({
                                    label: `${item.employee_matricule} - ${item.employee_firstname} ${item.employee_lastname}`,
                                    value: item.employee_id
                                }))}
                                value={this.state.user_employee_idDisplay}
                                openPopUp={this.props.createNewEmployee}
                                onChange={this.handleChangeEmployee}
                                // {...this.props}
                            />
                        </Grid>
                        
                        <Grid item xs={12} sm={6}>
                            <Creatable
                                label="Type d'Accès"
                                error={this.state.errors.user_type}
                                id="user_type"
                                options={Object.values(ACCESS).map( item => ({
                                    label: item.access_name,
                                    value: item.access_id
                                }))}
                                value={this.state.user_typeDisplay}
                                onChange={this.handleChangeAccess}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <InputText
                                name="user_collab_account" 
                                id="user_collab_account" 
                                value={this.state.user_collab_account} 
                                label="Compte Collaborateur" 
                                placeholder="47.." 
                                error={this.state.errors.user_collab_account} 
                                helperText={this.state.errors.user_collab_account} 
                                onChange={this.handleChange}
                            />
                        </Grid>
                        {/* <Grid item xs={12} sm={6}>
                            <InputText
                                name="user_super_email" 
                                id="user_super_email" 
                                value={this.state.user_super_email} 
                                label="Super Email" 
                                placeholder="super.email@example.com" 
                                error={this.state.errors.user_super_email} 
                                helperText={this.state.errors.user_super_email} 
                                onChange={this.handleChange}
                            />
                        </Grid> */}
                        {this.state.user_type &&
                            <Grid item xs={12}>
                                <Alert severity="info">
                                    <Typography >L'utilisateur aura accès aux pages suivantes : </Typography>
                                    {ACCESS[this.state.user_type].access_pages.map( page => (
                                        <Box>
                                            <Typography variant="button" >{PAGES[page]}</Typography>
                                        </Box>
                                    ))}
                                </Alert>
                            </Grid>
                        }
                    </Grid>
                </Box>
            </Dialog>
        )

    }
}

export default UserUpdate;